/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_No_Errors_For_EventInputs */



/**
* | output |
* | --- |
* | "No errors found for this event." |
*
* @param {Error_Nav_No_Errors_For_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_for_event = /** @type {((inputs?: Error_Nav_No_Errors_For_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_For_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune erreur trouvee pour cet evenement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für dieses Ereignis wurden keine Fehler gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun errore trovato per questo evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибок для этого события не обнаружено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron errores para este evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此事件未发现任何错误。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このイベントにエラーは見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस इवेंट में कोई त्रुटि नहीं पाई गई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum erro foi encontrado para este evento.")
	return /** @type {LocalizedString} */ ("No errors found for this event.")
});